
import { Injectable } from '@angular/core';
import config from 'src/app/config';
import { environment } from 'src/environments/environment';
import { AbstractPersonalUserDataService } from '../personal-user-data/personal-user-data.abstract.service';
import { AbstractAnalyticsService } from './analytics.abstract.service';
import { ClaroFlows, ClaroEvents } from './analytics.enum';
import mixpanel from 'mixpanel-browser';
import { AccountTypeEnum, CareerProcessTypeEnum, UserRole } from '../personal-user-data/personal-user-data';
import { InternalEventsManagerService } from '../internal-events-manager/internal-events-manager.service';
import { Locale } from '../../enum/locale.enum';


@Injectable({
 providedIn: 'root'
})


export class AnalyticsService implements AbstractAnalyticsService {
 private mixpanelToken : string;


 constructor(public personalUserDataService: AbstractPersonalUserDataService,
              private readonly internalEvents : InternalEventsManagerService)
 {
   this.mixpanelToken = environment.mixpanelToken;
   this.init();
 }


 init(): void {
   mixpanel.init(this.mixpanelToken, {
     api_host: 'https://api-eu.mixpanel.com',

     // Session Replay (user journey capture) — https://docs.mixpanel.com/docs/session-replay
     record_sessions_percent: 100,   // record 100% of sessions
     record_mask_all_text: false,    // Mixpanel default: mask all on-screen text in replays
     record_mask_all_inputs: false   // Mixpanel default: mask everything users type
   });

   // in case the user is already logged in
   this.identify();

   this.internalEvents.userLoggedIn.subscribe(()=>{
    // when the user logs in to the system - identify him
    this.identify();
   });
 }


 identify(userId = "") : void {
   const userDetails = this.user;

   // if userId is provided, use it
   if (userId != ""){
    mixpanel.identify(userId);
    return;
   }

   // userId is not provided, use the userDetails if exists
   if (userDetails != undefined){
    mixpanel.identify(userDetails.id);
   }
 }


 logout() {
   mixpanel.reset();
 }


 get user() {
   return this.personalUserDataService.getLoggedInUserPersonalData();
 }
  public send(eventName: string,
   eventCategory: string,
   eventAction: string,
   eventLabel: string = "",
   eventValue: Object = {}) {
     // gtag('event', eventName, {
     //               eventCategory: eventCategory,
     //               eventLabel: eventLabel,
     //               eventAction: eventAction,
     //               eventValue: JSON.stringify(eventValue)
     //           });
   console.log(`in AS send`);
 }


 public sendClaroEvent(eventName: string, eventValue: Object = {}, userIdOverride:string = "", orgIdOverride:string = "", mailAddressOverride: string ="" ){
     if (config.sendAnalytics) {
       let env = environment.production ? "prod":"local";


       let orgId = this.user?.orgId;
       if (orgId == undefined || orgId == ""){
         if (orgIdOverride != "")
           orgId = orgIdOverride;
         else
           orgId = "Undefined";
       }


      let userId = this.user?.id;
       if (userId == undefined || userId == ""){
         if (userIdOverride != "")
           userId = userIdOverride;
         else
           userId = "Undefined";
       }


       let email = this.user?.mailAddress;
       if (email == undefined || email == ""){
         if (mailAddressOverride != "")
           email = mailAddressOverride;
         else
           email = "Undefined";
       }

       let userRole = this.user?.role;
       if (userRole == undefined){
        userRole = UserRole.NONE;
       }

       let userAccountType = this.user?.accountType;
       if (userAccountType == undefined){
        userAccountType = AccountTypeEnum.UNKNOWN;
       }

      let isReseller = this.user?.isReseller;
      if (isReseller == undefined){
        isReseller = false;
      }

      let careerProcessType = this.user?.careerProcessType;
      if (careerProcessType == undefined){
        careerProcessType = CareerProcessTypeEnum.NONE;
      }

      let userLocale : string | Locale | undefined = this.user?.locale;
      if (userLocale == undefined){
        userLocale = "Undefined";
      }

      let parentId : string | undefined = this.user?.parentId;
      if (parentId == undefined){
        parentId = "Undefined";
      }

       mixpanel.track(eventName, {
           env: env,
           orgId: orgId,
           userId: userId,
           role: userRole,
           isReseller: isReseller,
           accountType: userAccountType,
           careerProcessType: careerProcessType,
           locale: userLocale,
           parentId: parentId,
           ...eventValue
           });


       // // console.log(`in sendClaroEvent event name is ${eventName} orgId is ${orgId} userId is ${userId} email is ${email} userFullName is ${userFullName}`);
       // gtag('event', eventName, {
       //   env: env,
       //   orgId: orgId,
       //   userId: userId,
       //   email: email,
       //   userFullName: userFullName,
       //   ...eventValue
       //   });
     }
   }


 public loginEvent(): void {
   this.sendClaroEvent(ClaroEvents.UserLoggedIn, {});
 }


 public tokenLoginEvent(): void {
   this.sendClaroEvent(ClaroEvents.UserLoggedInViaToken, {});
 }


 public discoveryProcessStartedEvent(): void {
   this.sendClaroEvent(ClaroEvents.DiscoveryProcessStarted, {});
 }


 public discoveryProcessResumedEvent(): void {
   this.sendClaroEvent(ClaroEvents.DiscoveryProcessResumed, {});
 }


 public discoveryProcessCompletedEvent(): void {
   this.sendClaroEvent(ClaroEvents.DiscoveryProcessCompleted, {});
 }


 public activeMoovStepCheckedEvent(): void {
   this.sendClaroEvent(ClaroEvents.ActiveMoovStepChecked, {});
 }


 public activeMoovStepCommentSavedEvent(): void {
   this.sendClaroEvent(ClaroEvents.ActiveMoovStepCommentSaved, {});
 }


 public makeMoovEvent(counterpartId:string, moovId: string, issueId: string, activeMoodId: string): void {
   this.sendClaroEvent(ClaroEvents.MakeMoov, {counterpartId:counterpartId, issueId:issueId, activeMoodId:activeMoodId});
 }


 public issueSelectedEvent(counterpartId:string, issueId: string): void {
   this.sendClaroEvent(ClaroEvents.IssueSelected, {counterpartId:counterpartId, issueId:issueId, claroFlow: ClaroFlows.SolveIssue});
 }


 public moovViewedEvent(counterpartId:string, issueId: string, moovId: string): void {
   this.sendClaroEvent(ClaroEvents.MoovViewed, {counterpartId:counterpartId, issueId:issueId, moovId:moovId, claroFlow: ClaroFlows.SolveIssue});
 }


 public showMoreMoovsSelected(counterpartId:string, issueId: string): void {
   this.sendClaroEvent(ClaroEvents.WizardShowMoreMoovsSelected, {counterpartId:counterpartId, issueId:issueId, claroFlow: ClaroFlows.SolveIssue});
 }


 public activeMoovViewedEvent(counterpartId:string, issueId: string, moovId: string, activeMoodId: string): void {
   this.sendClaroEvent(ClaroEvents.ActiveMoovViewed, {counterpartId:counterpartId, issueId:issueId, moovId:moovId, claroFlow: ClaroFlows.SolveIssue});
 }


 public activeMoovEndedEvent(counterpartId:string, issueId: string, moovId: string, activeMoodId: string): void {
   this.sendClaroEvent(ClaroEvents.ActiveMoovEnded, {counterpartId:counterpartId, issueId:issueId, moovId:moovId, claroFlow: ClaroFlows.SolveIssue});
 }


 public activeMoovExtendedEvent(counterpartId:string, issueId: string, moovId: string, activeMoodId: string): void {
   this.sendClaroEvent(ClaroEvents.ActiveMoovExtended, {counterpartId:counterpartId, issueId:issueId, moovId:moovId, claroFlow: ClaroFlows.SolveIssue});
 }


 public challengeFlowClickEvent(counterpartId: string): void {
   this.sendClaroEvent(ClaroEvents.ChallengeFlowClicked, {counterpartId:counterpartId, claroFlow: ClaroFlows.SolveIssue});
 }


 public teamMemberReviewed(counterpartId: string): void {
   this.sendClaroEvent(ClaroEvents.TeamMemberReviewed, {counterpartId:counterpartId});
 }

 public userUnsubscribedEvent(type:number): void {
   this.sendClaroEvent(ClaroEvents.UserUnsubscribed, {type});
 }


 public teamMemberReviewedFromExternalLink(counterpartId: string): void {
   this.sendClaroEvent(ClaroEvents.TeamMemberReviewed, {counterpartId:counterpartId});
 }


 public teamMemberInsightsReviewed(counterpartId: string): void {
   this.sendClaroEvent(ClaroEvents.TeamMemberInsightsReviewed, {counterpartId:counterpartId});
 }


 public userEngagementUnsubscribeEvent(): void{
   this.sendClaroEvent(ClaroEvents.UserEngagementUnsubscribeEvent, {});
 }


 public recommendedMoovReviewed(counterpartId: string, moovId: string): void {
   this.sendClaroEvent(ClaroEvents.RecommendedMoovReviewed, {counterpartId:counterpartId, moovId});
 }


 public teamMemberMoovsTabSelected(counterpartId: string): void {
   this.sendClaroEvent(ClaroEvents.TeamMemberMoovsTabSelected, {counterpartId:counterpartId});
 }


 public teamMemberInsightsTabSelected(counterpartId: string): void {
   this.sendClaroEvent(ClaroEvents.TeamMemberInsightsTabSelected, {counterpartId:counterpartId});
 }


 public moovFeedback(moovId: string, activeMoovId: string, moovRating: number, counterpartId: string): void{
   this.sendClaroEvent(ClaroEvents.MoovFeedback, {moovId:moovId, activeMoovId:activeMoovId, moovRating:moovRating, counterpartId:counterpartId});
 }


 public userRespondedToQuestioner(): void{
   this.sendClaroEvent (ClaroEvents.UserResponsedToQuestioner, {});
 }


 public userRespondedAgainToDriverGapQuestion(userId:string, orgId:string, mailAddress: string): void{
   this.sendClaroEvent (ClaroEvents.UserResponsedAgainToDriverGapQuestion, {}, userId, orgId, mailAddress);
 }


 public UserFailedToResponsedToQuestioner(): void{
   this.sendClaroEvent(ClaroEvents.UserFailedToResponsedToQuestioner, {});
 }


 public UserMutedQuestionVideo(): void{
   this.sendClaroEvent(ClaroEvents.UserMutedQuestionVideo, {});
 }


 public UserUnMutedQuestionVideo(): void{
   this.sendClaroEvent(ClaroEvents.UserUnMutedQuestionVideo, {});
 }
  public UserMutedIntroVideo(): void{
   this.sendClaroEvent(ClaroEvents.UserMutedIntroVideo, {});
 }


 public UserUnMutedIntroVideo(): void{
   this.sendClaroEvent(ClaroEvents.UserUnMutedIntroVideo, {});
 }


 public teamViewPage(): void{
   this.sendClaroEvent(ClaroEvents.TeamViewPage, {})
 }


 public teamMemberDetailsViewPage(): void{
   this.sendClaroEvent(ClaroEvents.TeamMemberDetailedViewPage, {})
 }


 public myMotivationsPage(): void {
   this.sendClaroEvent(ClaroEvents.MyMotivationsPage, {})
 }


 public specficMotivationPage(driverId: string): void{
   this.sendClaroEvent(ClaroEvents.SpecificMotivationPage, {driverId: driverId })
 }


 public userEndedQuestioner(): void{
   this.sendClaroEvent(ClaroEvents.UserEndedQuestioner);
 }
  public userStartedRediscovery(): void{
   this.sendClaroEvent(ClaroEvents.UserStartedRediscovery);
 }


 public userEndedRediscovery(): void{
   this.sendClaroEvent(ClaroEvents.UserEndedRediscovery);
 }


 public userHitMoreInfoOnTips(): void{
   this.sendClaroEvent(ClaroEvents.UserHitMoreInfoOnTips);
 }


 public userRespondedToDriverGapQuestion(userId:string, orgId:string, mailAddress: string): void{
   this.sendClaroEvent(ClaroEvents.UserRespondedToDriverGapQuestion,{},userId, orgId, mailAddress);
 }


 public userSelfRegistered(): void{
   this.sendClaroEvent(ClaroEvents.UserSelfRegistered);
 }
}
